// Card Analysis Service
// This service handles the analysis of trading card images

// Card Analysis Service
// Always use real API

// Analyze card using backend API
export const analyzeCard = async (imageData) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    const fullUrl = `${apiUrl}/api/analyze-card`;
    console.log('Backend API URL from env:', process.env.REACT_APP_API_URL);
    console.log('Using API URL:', apiUrl);
    console.log('Full endpoint URL:', fullUrl);
    console.log('Image data length:', imageData?.length || 0);
    
    const response = await fetch(fullUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ image: imageData })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to analyze card');
    }

    const data = await response.json();
    console.log('Received analysis data:', data);
    return data;
  } catch (error) {
    console.error('Card analysis error:', error);
    throw error;
  }
};

// These functions are now handled by the backend API
// The analyzeCard function above returns all necessary data including:
// - Card identification
// - Market prices from eBay
// - Authenticity verification
// - Market trends
// - Population data